module.exports = __webpack_public_path__ + "static/media/logo-full.707b8d9b.svg";